import { FC } from "react";
import Translate from "components/Translate/Translate";
import styled from "@emotion/styled";
import { CustomDialog } from "molecule/customDialog/CustomDialog";
import { CustomDialogHeading } from "molecule/customDialog/CustomDialogHeading";

const BehavioralCrisisWrapper = styled.div`
  padding: 24px;
`;

const BehavioralCrisisText = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  letter-spacing: -0.28px;
`;

const BehavioralCrisisTextBold = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  letter-spacing: -0.28px;
  margin-top: 16px;
`;

export const BehavioralCrisisHotlinePopup: FC = () => {
  return (
    <CustomDialog>
      <BehavioralCrisisWrapper>
        <CustomDialogHeading slot={"title"}>
          <Translate msg={"behavioralCrisisHotline.title"} />
        </CustomDialogHeading>
        <BehavioralCrisisText>
          <Translate msg={"behavioralCrisisHotline.message"} />
        </BehavioralCrisisText>
        <BehavioralCrisisTextBold>
          <Translate msg={"behavioralCrisisHotline.suicideAndLifeline"} />
        </BehavioralCrisisTextBold>
        <BehavioralCrisisText>
          <Translate msg={"behavioralCrisisHotline.callOrText"} />
        </BehavioralCrisisText>
        <BehavioralCrisisTextBold>
          <Translate msg={"behavioralCrisisHotline.amazonEmployee"} />
        </BehavioralCrisisTextBold>
        <BehavioralCrisisText>
          <Translate msg={"behavioralCrisisHotline.amazonCall"} />
        </BehavioralCrisisText>
      </BehavioralCrisisWrapper>
    </CustomDialog>
  );
};

export default BehavioralCrisisHotlinePopup;
